export const messagesKeys = {
    statuses: (messageId) => ['messages', messageId, 'statuses']
};
//# sourceMappingURL=messages.keys.js.map